module.exports = __webpack_public_path__ + "static/media/text_full.15ccbb6e.png";